import type { SvgIconProps } from './types';

export function GrFormNext(props: SvgIconProps) {
  return (
    <svg stroke="currentColor" fill="currentColor" strokeWidth={0} viewBox="0 0 24 24" height="1em" width="1em" {...props}><polyline fill="none" stroke="#000" strokeWidth={2} points="9 6 15 12 9 18" /></svg>
  );
}
